import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: [],
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.staticSegments,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].editSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Download Latest',
				id: 'download',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.staticSegments,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].downloadCsv,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Version History',
				id: 'versionHistory',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.staticSegments,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].showVersionHistory,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Delete Segment',
				id: 'delete',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.staticSegments,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments].deleteSegment,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.staticSegments,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.staticSegments]?.createSegment,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
